// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { ItemPart } from "@store/Framework/Types/ApiModels";
import React, { FC, useState } from "react";
import { css } from "styled-components";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { linkStyles } from "@store/Themes/common/mixins/link";
import translate from "@insite/client-framework/Translate";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import ChevronDown from "@store/Library/Components/Toolkit/Icons/ChevronDown";
import ChevronUp from "@store/Library/Components/Toolkit/Icons/ChevronUp";

interface OwnProps {
    partsList: ItemPart[];
}

type Props = OwnProps;

interface ItemPartsListStyles {
    partsListWrapper?: InjectableCss;
    link?: LinkPresentationProps;
}

export const itemPartsListStyles: ItemPartsListStyles = {
    partsListWrapper: {
        css: css`
            font-size: ${x => x.theme.design.typography.size.smallest};
            color: ${getColor("secondary")};
            margin-bottom: ${pxToRem(5)};
        `,
    },
    link: {
        css: css`
            ${linkStyles("text.link", "text.linkHover", false, true)}
            font-weight: ${x => x.theme.design.typography.weight.semibold};
            font-size: ${x => x.theme.design.typography.size.smallest};
        `,
        icon: {
            iconProps: {
                src: ChevronDown,
                size: 18,
                color: "text.link",
                css: css`
                    transform: translateY(${pxToRem(-1)});
                    margin-left: ${pxToRem(5)};
                `,
                mergeCss: true,
            },
            position: "right",
        },
    },
};

const styles = itemPartsListStyles;

const ItemPartsList: FC<Props> = ({ partsList }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    return (
        <>
            <Link
                {...styles.link}
                onClick={() => setIsExpanded(prev => !prev)}
                icon={{
                    ...styles.link?.icon,
                    iconProps: {
                        ...styles.link?.icon?.iconProps,
                        src: isExpanded ? ChevronUp : ChevronDown,
                    },
                }}
            >
                {translate("Parts Included")}
            </Link>
            {isExpanded && (
                <StyledWrapper>
                    {partsList.map(part => (
                        <StyledWrapper key={part.ProductSku} {...styles.partsListWrapper}>
                            {part.ProductSku} - Qty. {part.Quantity}
                        </StyledWrapper>
                    ))}
                </StyledWrapper>
            )}
        </>
    );
};

export default ItemPartsList;
